import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const userUnsubscribe = createAsyncThunk("userUnsubscribe", async (data) => {
  try {
    const response = await AxiosInstance.post(`${API_KEY}/api/dashboard/unsubscribe`, data, {
      "Content-Type": "application/json",
    });

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  userUnsubscribeData: null,
  isError: false,
  errorMessage: "",
};
const userUnsubscribeSlice = createSlice({
  name: "userUnsubscribe",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userUnsubscribe.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(userUnsubscribe.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userUnsubscribeData = action.payload;
    });
    builder.addCase(userUnsubscribe.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default userUnsubscribeSlice.reducer;
